import React, { useCallback, useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import {
  classduration,
  classSection,
  classSylabus,
  language,
  period,
  routinename,
  subjectGroup,
  teacher,
  Time,
  Timeto
} from "../../../core/common/selectoption/selectoption";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import TooltipOption from "../../../core/common/tooltipOption";
import { SingleValue } from "react-select";
import { _get, _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import TimetableCards from "./TimetableCards";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

const ClassTimetable = () => {
  const routes = all_routes;
  interface FormData {
    class_name: string;
    section: string;
    subject: string;
    teacher_id: string;
    school_location: string;
    day: string;
    time: string;
    period: string;
    duration: string;
    routinename: string;
    subjectClasses: string;
  }
  const _form = {
    class_name: "",
    section: "",
    subject: "",
    teacher_id: "",
    school_location: "",
    day: "Monday",
    time: "",
    period: "",
    duration: "",
    routinename: "",
    subjectClasses: "",
    query_type: "create",
    school_id: 1
  };
  interface Subjects {
    label: string;
    value: string;
  }
  const [subjects, setSubjects] = useState<Subjects[]>([]);
  const [form, setForm] = useState(_form);
  const [filter, setFilter] = useState({
    class_name: "",
    section: ""
  });
  const [teachers, setTeachers] = useState([]);
  const [timetable, setTimetable] = useState([]);
  const [classes, setClasses] = useState([]);

  // const { classes } = useSelector((state: any) => state.auth);
  const { user, sections } = useSelector((state: RootState) => state.auth);
  const isTeacher = user.role?.toLowerCase() === "teacher";
  const classOptions =
  classes?.length > 0
      ? classes?.map((item: any) => ({
          label: item.class_name,
          value: item.class_name,
        }))
      : [];

  // const sections = teacher_roles?.length
  //   ? Array.from(new Set(teacher_roles?.map((cls: any) => cls.section)))
  //   : [];

  const mapped_section = sections?.map((i: any) => ({
    label: i.section_name,
    value: i.section_name,
  }));

  useEffect(() => {
    _get(
      "teachers?query_type=select-all",
      (res) => {
        console.log(res);
        if(res.success && res.data && res.data.length) {
          setTeachers(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, []);

  const teacherOptions = teachers?.map((i: any) => ({
    label: i.name,
    value: i.id
  }));

  // useEffect(() => {
  //   if (form.class_name) {
  //     const section = classes?.length
  //       ? classes.find((x: any) => x.class_name === form.class_name)
  //           ?.section
  //       : "";
  //     console.error({ section });
  //   }
  // }, [form.class_name, subjects?.length]);

  useEffect(() => {
    _get(
      "subjects?query_type=select-all",
      (res) => {
        if(res.success && res.data && res.data.length) {
          setSubjects(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, []);

  const subjectOptions = subjects?.map((i: any) => ({
    label: i.subject,
    value: i.subject
  }));

  const handleSubmit = () => {
    const dataToSubmit =
      newContents.length === 1 && timeTableList?.length === 0
        ? [form]
        : timeTableList;

    console.log("Submitting data:", dataToSubmit);

    _post(
      "lesson_time_table?query_type=create",
      dataToSubmit,
      (res) => {
        if (res.success) {
          toast.success("Timetable submitted successfully!");
          setForm(_form);
          setNewContents([0]);
          setTimeTableList([]);
        }
      },
      (err) => {
        console.error("Submission error:", err);
        toast.error("An error occurred while submitting the timetable.");
      }
    );
  };

  useEffect(() => {
    if (form.section) {
      _get(
        `classes?query_type=select-section-classes&section=${form.section}&school_id=${user.school_id}`,
        (res) => {
          if (res.success && res.data && res.data.length) {
            setClasses(res.data);
          }else{
            setClasses([]);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }, [form.section, form.class_name, user.id]);

  const fetchTimetable = () => {
    if(form.section && form.class_name){
    _get(
      `lesson_time_table?query_type=select-class-subjects&section=${form.section}&class_name=${form.class_name}&school_id=${user.school_id}`,
      (res) => {
        if (res.success) {
          setTimetable(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  } else if(!isTeacher){
        _get(
          `lesson_time_table?query_type=select&section=${form.section}&school_id=${user.school_id}`,
          (res) => {
            if (res.success) {
              setTimetable(res.data);
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else {
          _get(
            `lesson_time_table?query_type=by_teacher&teacher_id=${user?.id}&school_id=${user.school_id}`,
            (res) => {
              if (res.success) {
                setTimetable(res.data);
                console.log(res.data);
              }
            },
            (err) => {
              console.log(err);
            }
          );
        }

  
  };

  useEffect(() => {
    fetchTimetable();
  }, [form.section, form.class_name, user]);

  const handleClassChange = (value: any, section: any) => {
    setForm((p) => ({ ...p, class_name: value, school_id: user.school_id }));
    setFilter((p) => ({ ...p, class_name: value }));
  };

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const [newContents, setNewContents] = useState<number[]>([0]);
  const [tuesdayContents, settuesdayContents] = useState<number[]>([0]);
  const [wednessdayContents, setwednessdayContents] = useState<number[]>([0]);
  const [thursdayContents, setthursdayContents] = useState<number[]>([0]);
  const [fridayContents, setfridayContents] = useState<number[]>([0]);
  const [timeTableList, setTimeTableList] = useState<FormData[]>([]);

  const addContent = (day: string) => {
    setTimeTableList((prev) => [...prev, form]);
    setForm((prev) => ({ ..._form, day: prev.day, school_id: user.school_id }));

    switch (day) {
      case "Monday":
        setNewContents((prev) => [...prev, newContents?.length]);
        break;
      case "Tuesday":
        settuesdayContents((prev) => [...prev, tuesdayContents?.length]);
        break;
      case "Wednesday":
        setwednessdayContents((prev) => [...prev, wednessdayContents?.length]);
        break;
      case "Thursday":
        setthursdayContents((prev) => [...prev, thursdayContents?.length]);
        break;
      case "Friday":
        setfridayContents((prev) => [...prev, fridayContents?.length]);
        break;
      default:
        break;
    }
  };

  const removeContent = (day: string, index: number) => {
    setTimeTableList((prev) => prev.filter((_, i) => i !== index));

    switch (day) {
      case "Monday":
        setNewContents((prev) => prev.filter((_, i) => i !== index));
        break;
      case "Tuesday":
        settuesdayContents((prev) => prev.filter((_, i) => i !== index));
        break;
      case "Wednesday":
        setwednessdayContents((prev) => prev.filter((_, i) => i !== index));
        break;
      case "Thursday":
        setthursdayContents((prev) => prev.filter((_, i) => i !== index));
        break;
      case "Friday":
        setfridayContents((prev) => prev.filter((_, i) => i !== index));
        break;
      default:
        break;
    }
  };

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Time Table</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Academic</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Time Table
                  </li>
                </ol>
              </nav> */}
            </div>
            {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add_time_table"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Time Table
                </Link>
              </div>
            </div> */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Time Table</h4>
              <div className="mb-3">
                <label className="form-label">Section</label>
                <CommonSelect
                  className="select"
                  options={mapped_section}
                  handleChange={(newValue: SingleValue<Option>) =>
                    setForm((prev) => ({
                      ...prev,
                      section: newValue ? newValue.value : ""
                    }))
                  }
                  defaultValue={{
                    label: form.section,
                    value: form.section
                  }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Class</label>
                <CommonSelect
                  options={classOptions}
                  defaultValue={{
                    label: form.class_name,
                    value: form.class_name
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    handleClassChange(newValue?.label, newValue?.value)
                  }
                />
              </div>
            </div>
            {/* {JSON.stringify(timetable)} */}
            <TimetableCards
              data={timetable}
              refreshData={fetchTimetable}
              section={form.section}
              class={form.class_name}
            />
            <div className="card-footer border-0 pb-0"></div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
        {/* Add Class Time Table */}
        <div className="modal fade" id="add_time_table">
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Time Table</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <CommonSelect
                          className="select"
                          options={mapped_section}
                          handleChange={(newValue: SingleValue<Option>) =>
                            setForm((prev) => ({
                              ...prev,
                              section: newValue ? newValue.value : ""
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">Class</label>
                        <CommonSelect
                          className="select"
                          options={classOptions}
                          handleChange={(newValue: SingleValue<Option>) =>
                            setForm((prev) => ({
                              ...prev,
                              class_name: newValue ? newValue.value : ""
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="add-more-timetable">
                    <ul
                      className="tab-links nav nav-pills"
                      id="pills-tab2"
                      role="tablist"
                    >
                      <li
                        className="nav-link active"
                        id="pills-monday-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-monday"
                        role="tab"
                        aria-controls="pills-monday"
                        aria-selected="true"
                      >
                        <Link
                          onClick={() => {
                            setForm((p) => ({ ...p, day: "Monday" }));
                          }}
                          to="#"
                        >
                          Monday
                        </Link>
                      </li>
                      <li
                        className="nav-link"
                        id="pills-tuesday-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-tuesday"
                        role="tab"
                        aria-controls="pills-tuesday"
                        aria-selected="false"
                        tabIndex={-1}
                      >
                        <Link
                          onClick={() => {
                            setForm((p) => ({ ...p, day: "Tuesday" }));
                          }}
                          to="#"
                        >
                          Tuesday
                        </Link>
                      </li>
                      <li
                        className="nav-link"
                        id="pills-wednesday-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-wednesday"
                        role="tab"
                        aria-controls="pills-wednesday"
                        aria-selected="false"
                        tabIndex={-1}
                      >
                        <Link
                          onClick={() => {
                            setForm((p) => ({ ...p, day: "Wednesday" }));
                          }}
                          to="#"
                        >
                          Wednesday
                        </Link>
                      </li>
                      <li
                        className="nav-link"
                        id="pills-thursday-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-thursday"
                        role="tab"
                        aria-controls="pills-thursday"
                        aria-selected="false"
                        tabIndex={-1}
                      >
                        <Link
                          onClick={() => {
                            setForm((p) => ({ ...p, day: "Thursday" }));
                          }}
                          to="#"
                        >
                          Thursday
                        </Link>
                      </li>
                      <li
                        className="nav-link"
                        id="pills-friday-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-friday"
                        role="tab"
                        aria-controls="pills-friday"
                        aria-selected="false"
                        tabIndex={-1}
                      >
                        <Link
                          onClick={() => {
                            setForm((p) => ({ ...p, day: "Friday" }));
                          }}
                          to="#"
                        >
                          Friday
                        </Link>
                      </li>
                    </ul>
                    <div className="tab-content pt-0 dashboard-tab">
                      <div
                        className="tab-pane fade show active"
                        id="pills-monday"
                        role="tabpanel"
                        aria-labelledby="pills-monday-tab"
                      >
                        {newContents?.map((_, index) => (
                          <div key={index} className="add-timetable-row">
                            <div className="row timetable-count">
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Subject</label>
                                  <CommonSelect
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        subject: newValue ? newValue.value : ""
                                      }))
                                    }
                                    options={subjectOptions}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Teacher</label>
                                  <CommonSelect
                                    className="select"
                                    options={teacherOptions}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        teacher_id: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Time From
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={Time}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        start_time: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="d-flex align-items-end">
                                  <div className="mb-3 flex-fill">
                                    <label className="form-label">
                                      Time To
                                    </label>
                                    <CommonSelect
                                      className="select"
                                      options={Timeto}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          end_time: newValue
                                            ? newValue.value
                                            : ""
                                        }))
                                      }
                                    />
                                  </div>
                                  {newContents?.length > 1 && (
                                    <div className="mb-3 ms-2">
                                      <Link
                                        to="#"
                                        className="delete-time-table"
                                        onClick={() =>
                                          removeContent("Monday", index)
                                        }
                                      >
                                        <i className="ti ti-trash" />
                                      </Link>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div>
                          <Link
                            to="#"
                            className="btn btn-primary add-new-timetable"
                            onClick={() => addContent("Monday")}
                          >
                            <i className="ti ti-square-rounded-plus-filled me-2" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-tuesday"
                        role="tabpanel"
                        aria-labelledby="pills-tuesday-tab"
                      >
                        {tuesdayContents?.map((_, index) => (
                          <div className="add-timetable-row">
                            <div className="row timetable-count">
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Subject</label>
                                  <CommonSelect
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        subject: newValue ? newValue.value : ""
                                      }))
                                    }
                                    options={subjectOptions}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Teacher</label>
                                  <CommonSelect
                                    className="select"
                                    options={teacherOptions}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        teacher_id: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Time From
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={Time}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        start_time: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="d-flex align-items-end">
                                  <div className="mb-3 flex-fill">
                                    <label className="form-label">
                                      Time To
                                    </label>
                                    <CommonSelect
                                      className="select"
                                      options={Timeto}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          end_time: newValue
                                            ? newValue.value
                                            : ""
                                        }))
                                      }
                                    />
                                  </div>
                                  {tuesdayContents?.length > 1 && (
                                    <div className="mb-3 ms-2">
                                      <Link
                                        to="#"
                                        className="delete-time-table"
                                        onClick={() =>
                                          removeContent("Tuesday", index)
                                        }
                                      >
                                        <i className="ti ti-trash" />
                                      </Link>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div>
                          <Link
                            to="#"
                            onClick={() => addContent("Tuesday")}
                            className="btn btn-primary add-new-timetable"
                          >
                            <i className="ti ti-square-rounded-plus-filled me-2" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-wednesday"
                        role="tabpanel"
                        aria-labelledby="pills-wednesday-tab"
                      >
                        {wednessdayContents?.map((_, index) => (
                          <div key={index} className="add-timetable-row">
                            <div className="row timetable-count">
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Subject</label>
                                  <CommonSelect
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        subject: newValue ? newValue.value : ""
                                      }))
                                    }
                                    options={subjectOptions}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Teacher</label>
                                  <CommonSelect
                                    className="select"
                                    options={teacherOptions}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        teacher_id: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Time From
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={Time}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        start_time: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="d-flex align-items-end">
                                  <div className="mb-3 flex-fill">
                                    <label className="form-label">
                                      Time To
                                    </label>
                                    <CommonSelect
                                      className="select"
                                      options={Timeto}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          end_time: newValue
                                            ? newValue.value
                                            : ""
                                        }))
                                      }
                                    />
                                  </div>
                                  {wednessdayContents?.length > 1 && (
                                    <div className="mb-3 ms-2">
                                      <Link
                                        to="#"
                                        className="delete-time-table"
                                        onClick={() =>
                                          removeContent("Wednesday", index)
                                        }
                                      >
                                        <i className="ti ti-trash" />
                                      </Link>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div>
                          <Link
                            to="#"
                            className="btn btn-primary add-new-timetable"
                            onClick={() => addContent("Wednesday")}
                          >
                            <i className="ti ti-square-rounded-plus-filled me-2" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-thursday"
                        role="tabpanel"
                        aria-labelledby="pills-thursday-tab"
                      >
                        {thursdayContents?.map((_, index) => (
                          <div key={index} className="add-timetable-row">
                            <div className="row timetable-count">
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Subject</label>
                                  <CommonSelect
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        subject: newValue ? newValue.value : ""
                                      }))
                                    }
                                    options={subjectOptions}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Teacher</label>
                                  <CommonSelect
                                    className="select"
                                    options={teacherOptions}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        teacher_id: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Time From
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={Time}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        start_time: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="d-flex align-items-end">
                                  <div className="mb-3 flex-fill">
                                    <label className="form-label">
                                      Time To
                                    </label>
                                    <CommonSelect
                                      className="select"
                                      options={Timeto}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          end_time: newValue
                                            ? newValue.value
                                            : ""
                                        }))
                                      }
                                    />
                                  </div>
                                  {thursdayContents?.length > 1 && (
                                    <div className="mb-3 ms-2">
                                      <Link
                                        to="#"
                                        className="delete-time-table"
                                        onClick={() =>
                                          removeContent("Thursday", index)
                                        }
                                      >
                                        <i className="ti ti-trash" />
                                      </Link>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div>
                          <Link
                            to="#"
                            className="btn btn-primary add-new-timetable"
                            onClick={() => addContent("Thursday")}
                          >
                            <i className="ti ti-square-rounded-plus-filled me-2" />
                            Add New
                          </Link>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-friday"
                        role="tabpanel"
                        aria-labelledby="pills-friday-tab"
                      >
                        {fridayContents?.map((_, index) => (
                          <div key={index}  className="add-timetable-row">
                            <div className="row timetable-count">
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Subject</label>
                                  <CommonSelect
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        subject: newValue ? newValue.value : ""
                                      }))
                                    }
                                    options={subjectOptions}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">Teacher</label>
                                  <CommonSelect
                                    className="select"
                                    options={teacherOptions}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        teacher_id: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Time From
                                  </label>
                                  <CommonSelect
                                    className="select"
                                    options={Time}
                                    handleChange={(
                                      newValue: SingleValue<Option>
                                    ) =>
                                      setForm((prev) => ({
                                        ...prev,
                                        start_time: newValue
                                          ? newValue.value
                                          : ""
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="d-flex align-items-end">
                                  <div className="mb-3 flex-fill">
                                    <label className="form-label">
                                      Time To
                                    </label>
                                    <CommonSelect
                                      className="select"
                                      options={Timeto}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          end_time: newValue
                                            ? newValue.value
                                            : ""
                                        }))
                                      }
                                    />
                                  </div>
                                  {fridayContents?.length > 1 && (
                                    <div className="mb-3 ms-2">
                                      <Link
                                        to="#"
                                        className="delete-time-table"
                                        onClick={() =>
                                          removeContent("Friday", index)
                                        }
                                      >
                                        <i className="ti ti-trash" />
                                      </Link>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div>
                          <Link
                            to="#"
                            className="btn btn-primary add-new-timetable"
                            onClick={() => addContent("Friday")}
                          >
                            <i className="ti ti-square-rounded-plus-filled me-2" />
                            Add New
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleSubmit}
                  >
                    Add Time Table
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Class Time Table */}
      </>
    </div>
  );
};

export default ClassTimetable;
